import { render } from "./MyGlobalRadioProSupport.vue?vue&type=template&id=761ccc3e&scoped=true"
import script from "./MyGlobalRadioProSupport.vue?vue&type=script&lang=js"
export * from "./MyGlobalRadioProSupport.vue?vue&type=script&lang=js"

import "./MyGlobalRadioProSupport.vue?vue&type=style&index=0&id=761ccc3e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761ccc3e"]])

export default __exports__